let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3V7D1")).then(() => parcelRequire('lnyUd'));